<template>
  <div>
        <sdPageHeader :title="isEditMode ? 'Template bewerken' : 'Template aanmaken'">
          <template #buttons>
            <a-button v-if="isEditMode && can('update', 'productcommunicationtemplate')" 
                      :loading="loadingPatchTemplate" 
                      type="primary" 
                      @click="saveTemplate">
              Opslaan
            </a-button>
            <a-button v-if="isEditMode && can('validate', 'productcommunicationtemplate')" 
                      :loading="loadingValidate" 
                      @click="validateTemplate">
              Valideer
            </a-button>
            <a-button v-if="isEditMode && can('previewemail', 'productcommunicationtemplate') && templateType === 'EMAIL'"
                      @click="showPreviewModal = true">
              Preview
            </a-button>
            <a-button v-if="isEditMode && can('previewpdf', 'productcommunicationtemplate') && templateType === 'PDF'"
                      @click="showPreviewModal = true">
              Preview
            </a-button>
          </template>
        </sdPageHeader>

    <Main v-if="errorTemplate">
      <sdCards title="">
        <a-result status="warning" style="padding: 0"
                  title="Er is een fout opgetreden bij het ophalen van de gegevens.">
          <template #extra>
            <a-button class="ant-btn ant-btn-primary" size="large" type="primary" @click="router.replace('/template')">
              Naar templates
            </a-button>
          </template>
        </a-result>
      </sdCards>
    </Main>

    <Main v-if="loadingTemplate">
      <sdCards>
        <a-skeleton active/>
      </sdCards>
    </Main>

    <Main v-else-if="!loadingTemplate">
      <a-row :gutter="15">
        <a-col :md="24" :xs="24">
          <sdCards title="Template Editor">
            <div style="height: calc(100vh - 300px); min-height: 600px; border: 1px solid #d9d9d9; position: relative;">
              <div v-if="loadingEditor" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; background: white; z-index: 10;">
                <a-spin size="large" tip="Editor laden..."/>
              </div>
              <div v-if="editorError" style="padding: 20px;">
                <a-alert type="warning" message="Monaco Editor kon niet worden geladen" :description="editorError" />
                <a-textarea 
                  v-model:value="form.html" 
                  :rows="25" 
                  placeholder="HTML template..."
                  style="margin-top: 20px; font-family: monospace;"
                />
              </div>
              <div ref="editorContainer" style="height: 100%; width: 100%;"></div>
            </div>
          </sdCards>
        </a-col>
      </a-row>

      <a-row :gutter="15" style="margin-top: 15px;">
        <a-col :md="24">
          <sdCards title="Template Details">
            <a-form :model="form" layout="vertical">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-form-item label="Naam" name="name">
                    <a-input v-model:value="form.name" :disabled="!can('update', 'productcommunicationtemplate')" placeholder=""/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="Type" name="type">
                    <a-select v-model:value="form.type" 
                              :disabled="!can('update', 'productcommunicationtemplate')" 
                              size="large" 
                              class="sDash_fullwidth-select">
                      <a-select-option value="EMAIL">Email</a-select-option>
                      <a-select-option value="PDF">PDF</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item name="hasMargin">
                    <a-checkbox v-model:checked="form.hasMargin" :disabled="!can('update', 'productcommunicationtemplate')">
                      Heeft marge
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="isEditMode && can('update', 'productcommunicationtemplate')">
                <a-col :span="24">
                  <div class="sDash_form-action" style="margin-top: 16px;">
                    <a-button type="primary"
                              :loading="loadingPatchTemplate"
                              size="large"
                              @click="saveTemplate">
                      Opslaan
                    </a-button>
                  </div>
                </a-col>
              </a-row>
            </a-form>
          </sdCards>
        </a-col>
      </a-row>

    </Main>

    <!-- Preview Modal -->
    <a-modal
        v-model:visible="showPreviewModal"
        :title="'Preview - ' + form.name"
        :width="'100%'"
        :style="{ top: 0, paddingBottom: 0 }"
        :bodyStyle="{ height: 'calc(100vh - 110px)', padding: 0 }"
        :maskClosable="false"
        :closable="true"
        class="full-width-modal"
        @cancel="handlePreviewModalClose"
    >
      <template #footer>
        <a-button @click="handlePreviewModalClose">Sluiten</a-button>
      </template>
      <div style="display: flex; flex-direction: column; height: 100%;">
        <div style="padding: 20px; border-bottom: 1px solid #d9d9d9;">
          <a-form-item label="Order ID voor preview">
            <div style="display: flex; gap: 8px; align-items: flex-start;">
              <a-input-number
                  v-model:value="selectedOrderId"
                  placeholder="Voer order ID in..."
                  :min="1"
                  :precision="0"
                  style="flex: 1"
              />
              <a-button 
                  type="primary" 
                  :loading="loadingPreview"
                  :disabled="!selectedOrderId || isNaN(selectedOrderId)"
                  @click="previewTemplate"
              >
                Preview ophalen
              </a-button>
            </div>
          </a-form-item>
        </div>
        <div style="flex: 1; overflow: hidden; position: relative;">
          <div v-if="loadingPreview" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; background: white; z-index: 10;">
            <a-spin size="large" tip="Preview genereren..."/>
          </div>
          <div v-if="templateType === 'EMAIL'" style="height: 100%; overflow: auto; padding: 20px;">
            <div v-if="previewHtml" v-html="previewHtml"></div>
            <div v-else style="text-align: center; color: #999; padding-top: 50px;">
              Selecteer een order om preview te zien
            </div>
          </div>
          <div v-else style="height: 100%;">
            <div v-if="previewPdfUrl" id="template-pdf-viewer" style="width: 100%; height: 100%; box-shadow: 1px 1px 10px 1px #dadada; display: flex; flex-flow: column;"></div>
            <div v-else style="padding: 20px; text-align: center; color: #999;">
              Voer een order ID in en klik op 'Preview ophalen' om de PDF preview te zien.
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- Validation Modal -->
    <a-modal v-model:visible="showValidationModal" title="Validatie Resultaten" :footer="null">
      <div v-if="validationData">
        <a-alert 
          v-if="validationData.valid" 
          type="success" 
          message="Validatie geslaagd!" 
          description="De template is geldig en bevat geen errors."
          style="margin-bottom: 20px;"
        />
        <a-alert 
          v-else 
          type="error" 
          message="Validatie gefaald" 
          description="De template bevat errors die moeten worden opgelost."
          style="margin-bottom: 20px;"
        />
        
        <div v-if="validationErrors.length > 0">
          <h4>Errors:</h4>
          <ul>
            <li v-for="(error, index) in validationErrors" :key="index">
              Regel {{ error.line }}: {{ error.message }}
            </li>
          </ul>
        </div>
        
        <div v-if="validationData.warnings && validationData.warnings.length > 0">
          <h4 style="margin-top: 20px;">Waarschuwingen:</h4>
          <ul>
            <li v-for="(warning, index) in validationData.warnings" :key="index">
              {{ warning.message || warning }}
            </li>
          </ul>
        </div>
        
        <div v-if="validationData.valid && (!validationErrors.length || validationErrors.length === 0) && (!validationData.warnings || validationData.warnings.length === 0)">
          <p>Geen errors of waarschuwingen gevonden.</p>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {computed, defineComponent, onMounted, onBeforeUnmount, ref, reactive, watch, nextTick} from 'vue';
import {useStore} from 'vuex';
import {useRoute, useRouter} from 'vue-router';
import {useAbility} from '@casl/vue';
import {Main} from '../styled';
// Monaco Editor will be loaded via CDN

const TemplateEditor = defineComponent({
  name: 'TemplateEditor',
  components: {Main},
  setup() {
    const {state, dispatch} = useStore();
    const route = useRoute();
    const router = useRouter();
    const {can} = useAbility();
    const isEditMode = computed(() => !!route.params.id);
    const template = computed(() => state.productCommunicationTemplate.template);
    const loadingTemplate = computed(() => state.productCommunicationTemplate.loadingTemplate);
    const errorTemplate = computed(() => state.productCommunicationTemplate.errorTemplate);
    const loadingPatchTemplate = computed(() => state.productCommunicationTemplate.loadingPatchTemplate);
    const loadingValidate = computed(() => state.productCommunicationTemplate.loadingValidate);
    const validationData = computed(() => state.productCommunicationTemplate.validationData);
    const previewData = computed(() => state.productCommunicationTemplate.previewData);
    
    const form = reactive({
      name: '',
      html: '',
      type: 'EMAIL',
      productType: null,
      hasMargin: false,
    });
    
    const previewHtml = ref('');
    const previewPdfUrl = ref('');
    const validationErrors = ref([]);
    const showValidationModal = ref(false);
    const showPreviewModal = ref(false);
    const selectedOrderId = ref(null);
    const loadingPreview = computed(() => state.productCommunicationTemplate.loadingPreview);
    
    const templateType = computed(() => form.type);
    const editorContainer = ref(null);
    const loadingEditor = ref(true);
    const editorError = ref(null);
    let editorInstance = null;
    let monaco = null;
    let debounceTimer = null;
    
    // Initialize Monaco Editor
    const initMonaco = async () => {
      await nextTick();
      
      // Wait for container to be available
      let retries = 0;
      while (!editorContainer.value && retries < 10) {
        await new Promise(resolve => setTimeout(resolve, 100));
        await nextTick();
        retries++;
      }
      
      if (!editorContainer.value) {
        loadingEditor.value = false;
        editorError.value = 'Editor container niet gevonden';
        return;
      }
      
      if (editorInstance) {
        loadingEditor.value = false;
        return;
      }
      
      try {
        // Check if Monaco is loaded via CDN script tag
        if (window.require && window.require.config) {
          window.require.config({ paths: { vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.44.0/min/vs' } });
          await new Promise((resolve, reject) => {
            window.require(['vs/editor/editor.main'], (monacoModule) => {
              monaco = monacoModule;
              resolve();
            }, (error) => {
              reject(error);
            });
          });
        } else {
          // Set timeout for loading
          const timeoutPromise = new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Monaco Editor load timeout (10s)')), 10000)
          );
          
          // Use loader to load Monaco Editor
          const loaderModule = await import('@monaco-editor/loader');
          const initPromise = loaderModule.default.init();
          
          monaco = await Promise.race([initPromise, timeoutPromise]);
        }
        
        if (!monaco || !monaco.editor) {
          loadingEditor.value = false;
          editorError.value = 'Monaco Editor niet correct geladen';
          return;
        }
        
        if (!editorContainer.value) {
          loadingEditor.value = false;
          editorError.value = 'Editor container is null';
          return;
        }
        
        editorInstance = monaco.editor.create(editorContainer.value, {
          value: form.html || '',
          language: 'html',
          theme: 'vs-dark',
          automaticLayout: true,
          minimap: { enabled: true },
          wordWrap: 'on',
          fontSize: 14,
          lineNumbers: 'on',
          scrollBeyondLastLine: false,
        });
        
        editorInstance.onDidChangeModelContent(() => {
          form.html = editorInstance.getValue();
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            if (isEditMode.value && showPreviewModal.value && selectedOrderId.value && !isNaN(selectedOrderId.value)) {
              previewTemplate();
            }
          }, 1000);
        });
        
        loadingEditor.value = false;
        editorError.value = null;
      } catch (error) {
        loadingEditor.value = false;
        editorError.value = error.message || 'Onbekende fout bij het laden van de editor';
      }
    };
    
    // Watch for HTML changes and debounce preview
    watch(() => form.html, () => {
      if (editorInstance && form.html !== editorInstance.getValue()) {
        editorInstance.setValue(form.html);
      }
    });
    
    // Load template
    const loadTemplate = async () => {
      if (isEditMode.value) {
        await dispatch('getTemplate', route.params.id);
      }
    };
    
    // Watch template changes
    watch(() => template.value, (newTemplate) => {
      if (newTemplate && newTemplate.id) {
        form.name = newTemplate.name || '';
        form.html = newTemplate.html || '';
        form.type = newTemplate.type || 'EMAIL';
        form.productType = newTemplate.productType || null;
        form.hasMargin = newTemplate.hasMargin || false;
        
        if (editorInstance && form.html) {
          editorInstance.setValue(form.html);
        }
      }
    }, { immediate: true });
    
    
    // Load PDF in Adobe DC View - using same approach as PdfViewer component
    const loadPdfInViewer = (blobUrl) => {
      const viewerDiv = document.getElementById('template-pdf-viewer');
      if (!viewerDiv) {
        return;
      }
      
      // Clear previous content
      viewerDiv.innerHTML = '';
      
      // Check if Adobe DC View is available
      // eslint-disable-next-line no-undef
      if (typeof AdobeDC === 'undefined' || !AdobeDC.View) {
        const iframe = document.createElement('iframe');
        iframe.src = blobUrl;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';
        viewerDiv.appendChild(iframe);
        return;
      }
      
      // Wait a bit before loading, similar to PdfViewer component
      setTimeout(() => {
        try {
          const viewerConfig = {
            embedMode: 'SIZED_CONTAINER',
            showPageControls: true,
          };
          
          // eslint-disable-next-line no-undef
          const adobeDCView = new AdobeDC.View({
            clientId: '6ab6a54f8fee419c90824e2671d67a5e',
            divId: 'template-pdf-viewer',
          });
          
          adobeDCView.previewFile({
            content: {
              location: {
                url: blobUrl,
              },
            },
            metaData: {
              fileName: `${form.name || 'template'}.pdf`,
            },
          }, viewerConfig);
        } catch (error) {
          // Fallback to iframe
          const iframe = document.createElement('iframe');
          iframe.src = blobUrl;
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none';
          viewerDiv.appendChild(iframe);
        }
      }, 1000);
    };
    
    // Handle preview modal close - clean up
    const handlePreviewModalClose = () => {
      showPreviewModal.value = false;
      // Clean up preview data
      previewHtml.value = '';
      if (previewPdfUrl.value) {
        URL.revokeObjectURL(previewPdfUrl.value);
        previewPdfUrl.value = '';
      }
      // Clear PDF viewer
      const viewerDiv = document.getElementById('template-pdf-viewer');
      if (viewerDiv) {
        viewerDiv.innerHTML = '';
      }
      selectedOrderId.value = null;
    };
    
    // Preview template
    const previewTemplate = async () => {
      if (!isEditMode.value) return;
      
      const orderID = selectedOrderId.value ? parseInt(selectedOrderId.value, 10) : (route.query.orderID ? parseInt(route.query.orderID, 10) : null);
      if (!orderID || isNaN(orderID)) return;
      
      if (!can('previewemail', 'productcommunicationtemplate') && templateType.value === 'EMAIL') {
        return;
      }
      
      if (!can('previewpdf', 'productcommunicationtemplate') && templateType.value === 'PDF') {
        return;
      }
      
      if (!can('view', 'order')) {
        return;
      }
      
      try {
        if (templateType.value === 'EMAIL') {
          await dispatch('previewEmailTemplate', {
            id: route.params.id,
            orderID: orderID,
            html: form.html,
          });
        } else {
          await dispatch('previewPdfTemplate', {
            id: route.params.id,
            orderID: orderID,
            html: form.html,
          });
        }
      } catch (error) {
        // Error is handled by the action creator
      }
    };
    
    // Watch preview data
    watch(() => previewData.value, (newPreview) => {
      if (newPreview) {
        if (templateType.value === 'EMAIL') {
          // For email, the response should be an object with html property
          previewHtml.value = (typeof newPreview === 'string' ? newPreview : newPreview.html) || '';
        } else {
          // For PDF, the response is a blob
          // Clean up previous URL if exists
          if (previewPdfUrl.value) {
            URL.revokeObjectURL(previewPdfUrl.value);
          }
          
          // Create blob URL for PDF
          let blob;
          if (newPreview instanceof Blob) {
            // Already a Blob, use it directly
            blob = newPreview;
          } else if (newPreview instanceof ArrayBuffer) {
            blob = new Blob([newPreview], { type: 'application/pdf' });
          } else if (typeof newPreview === 'string') {
            // PDF content as string - convert to Uint8Array then Blob
            const bytes = new Uint8Array(newPreview.length);
            for (let i = 0; i < newPreview.length; i++) {
              bytes[i] = newPreview.charCodeAt(i);
            }
            blob = new Blob([bytes], { type: 'application/pdf' });
          } else {
            // For any other type, try to create a Blob from it
            blob = new Blob([newPreview], { type: 'application/pdf' });
          }
          
          previewPdfUrl.value = URL.createObjectURL(blob);
          
          // Load PDF in Adobe DC View directly in the preview modal
          nextTick(() => {
            loadPdfInViewer(previewPdfUrl.value);
          });
        }
      } else {
        // Clear preview when data is null
        if (templateType.value === 'EMAIL') {
          previewHtml.value = '';
        } else {
          if (previewPdfUrl.value) {
            URL.revokeObjectURL(previewPdfUrl.value);
            previewPdfUrl.value = '';
          }
          // Clear PDF viewer
          const viewerDiv = document.getElementById('template-pdf-viewer');
          if (viewerDiv) {
            viewerDiv.innerHTML = '';
          }
        }
      }
    });
    
    // Validate template
    const validateTemplate = async () => {
      if (!isEditMode.value) return;
      
      if (!can('validate', 'productcommunicationtemplate')) {
        return;
      }
      
      await dispatch('validateTemplate', {
        id: route.params.id,
        html: form.html,
        type: form.type,
      });
    };
    
    // Watch validation data
    watch(() => validationData.value, (newValidation) => {
      if (newValidation) {
        validationErrors.value = newValidation.errors || [];
        // Show modal with validation results
        showValidationModal.value = true;
      }
    });
    
    // Save template
    const saveTemplate = async () => {
      if (!isEditMode.value) return;
      
      if (!can('update', 'productcommunicationtemplate')) {
        return;
      }
      
      await dispatch('patchTemplate', {
        id: route.params.id,
        name: form.name,
        html: form.html,
        type: form.type,
        productType: form.productType,
        hasMargin: form.hasMargin,
      });
    };
    
    // Store original error handlers for cleanup
    let originalErrorHandler = null;
    let originalUnhandledRejection = null;
    
    onMounted(async () => {
      // Add error handler to ignore Adobe DC View SDK feature flag errors
      originalErrorHandler = window.onerror;
      window.onerror = (message, source, lineno, colno, error) => {
        // Ignore all Adobe DC View SDK feature flag errors
        if (message && typeof message === 'string' && message.includes('GET_FEATURE_FLAG')) {
          return true; // Suppress error
        }
        // Call original error handler for other errors
        if (originalErrorHandler) {
          return originalErrorHandler(message, source, lineno, colno, error);
        }
        return false;
      };
      
      // Also handle unhandled promise rejections
      originalUnhandledRejection = window.onunhandledrejection;
      window.onunhandledrejection = (event) => {
        // Ignore all Adobe DC View SDK feature flag errors
        if (event.reason && event.reason.message && typeof event.reason.message === 'string' && 
            event.reason.message.includes('GET_FEATURE_FLAG')) {
          event.preventDefault();
          return;
        }
        // Also check error object directly
        if (event.reason && typeof event.reason === 'object' && event.reason.message && 
            typeof event.reason.message === 'string' && event.reason.message.includes('GET_FEATURE_FLAG')) {
          event.preventDefault();
          return;
        }
        // Call original handler for other errors
        if (originalUnhandledRejection) {
          originalUnhandledRejection(event);
        }
      };
      
      await loadTemplate();
      // Wait for DOM to be ready
      await nextTick();
      await nextTick(); // Double nextTick to ensure DOM is ready
      initMonaco();
    });
    
    onBeforeUnmount(() => {
      // Restore original error handlers
      if (originalErrorHandler) {
        window.onerror = originalErrorHandler;
      }
      if (originalUnhandledRejection) {
        window.onunhandledrejection = originalUnhandledRejection;
      }
      
      if (editorInstance) {
        editorInstance.dispose();
        editorInstance = null;
      }
      if (previewPdfUrl.value) {
        URL.revokeObjectURL(previewPdfUrl.value);
      }
      clearTimeout(debounceTimer);
    });
    
    watch(() => template.value, () => {
      if (template.value && template.value.html) {
        form.html = template.value.html;
        form.name = template.value.name || '';
        form.type = template.value.type || 'EMAIL';
        form.productType = template.value.productType || null;
        form.hasMargin = template.value.hasMargin || false;
      }
    }, { immediate: true });
    
    return {
      isEditMode,
      template,
      loadingTemplate,
      errorTemplate,
      loadingPatchTemplate,
      loadingValidate,
      form,
      previewHtml,
      previewPdfUrl,
      validationErrors,
      validationData,
      templateType,
      showValidationModal,
      validateTemplate,
      saveTemplate,
      can,
      router,
      loadingEditor,
      editorContainer,
      editorError,
      selectedOrderId,
      loadingPreview,
      showPreviewModal,
      handlePreviewModalClose,
      previewTemplate,
    };
  },
});

export default TemplateEditor;
</script>

